import { render, staticRenderFns } from "./SceneTree.vue?vue&type=template&id=7be5aace&scoped=true&"
import script from "./SceneTree.vue?vue&type=script&lang=js&"
export * from "./SceneTree.vue?vue&type=script&lang=js&"
import style0 from "./SceneTree.vue?vue&type=style&index=0&id=7be5aace&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be5aace",
  null
  
)

export default component.exports